module.exports = __webpack_public_path__ + "static/media/trusted_site__.121ee3fc.svg";